import { getJsonOrError } from '../../utils/fetch'
import { queryString } from '../../utils/window'
import { getApiServicesEndpoints } from '../../application/pageDataObject'
import { getCountryCode } from '../../providers/geolocationProvider'
import { getSite } from '../../application/pageDataObject'

function getDate(localTime) {
  const date = queryString.localTime
    ? new Date(queryString.localTime)
    : new Date(localTime.getTime() - localTime.getTimezoneOffset() * 60000)
  date.setSeconds(0, 0)
  return date
}

export async function getCampaignsFromCampaignManagerService(site, country, localTime) {
  const result = await getJsonOrError(
    `${getApiServicesEndpoints().campaigns}?site=${site}&country=${country}&localTime=${getDate(
      localTime
    ).toJSON()}`
  )
  return result.data
}

let campaigns

export async function getCampaignsFromCampaignManager() {
  if (!campaigns) {
    const countryCode = await getCountryCode()
    campaigns = await getCampaignsFromCampaignManagerService(getSite(), countryCode, new Date())
  }
  return campaigns
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/campaignManager/campaignManagerProvider.js